import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "../pages/Login";
import BuildProductMatrix from "../pages/BuildStoreMatrix";
import ViewProductStoreMatrix from "../pages/ViewProductStoreMatrix";
import ManageGroups from "../pages/ManageGroups";
import ViewAuditLogs from "../pages/ViewAuditLogs";
import ImportStoreMatrix from "../pages/ImportStoreMatrix";
import ProtectedRoute from "../context/ProtectedRoute";
import ManageUsers from "../pages/ManageUsers";
import Dashboard from "../pages/Dashboard";

const AppRoutes = ({ currentUser }) => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/build-store-matrix"
        element={
          <ProtectedRoute>
            <BuildProductMatrix />
          </ProtectedRoute>
        }
      />
      <Route
        path="/view-store-matrix"
        element={
          <ProtectedRoute>
            <ViewProductStoreMatrix />
          </ProtectedRoute>
        }
      />
      <Route
        path="/view-audit-logs"
        element={
          <ProtectedRoute>
            <ViewAuditLogs />
          </ProtectedRoute>
        }
      />
      <Route
        path="/import-store-matrix"
        element={
          <ProtectedRoute>
            <ImportStoreMatrix />
          </ProtectedRoute>
        }
      />
      <Route
        path="/manage-groups"
        element={
          <ProtectedRoute>
            <ManageGroups />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/manage-users"
        element={
          <ProtectedRoute>
            <ManageUsers />
          </ProtectedRoute>
        }
      />
      <Route path="/admin" element={<div>Admin Panel</div>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;
